import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'accountCreatedNotification.title',
        defaultMessage: 'My account'
    },
    setupAccountMessage: {
        id: 'accountCreatedNotification.setupAccountMessage',
        defaultMessage: 'We’ve set up an account for:'
    },

    howToSetPassword: {
        id: 'accountCreatedNotification.howToSetPassword',
        defaultMessage: 'We’ve sent you an email so you can set your password.'
    },
    cta: {
        id: 'accountCreatedNotification.cta',
        defaultMessage: 'Got it'
    }
});
